/**
 * Market making management API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface TradingCompId {
  compId?: string;
  connected?: boolean;
  lastConnectionStateChangeTime?: string;
}
